import { useRecoilCallback } from 'recoil';
import { clearAnnotations } from '~/state/atoms/annotationListAtoms';
import {
    highlightedMeasurementState,
    measurementDraftState,
    measurementListState,
} from '~/state/atoms/measurementAtoms';

/**
 * Returns a callback that clears all measurement state (committed list,
 * in-progress draft, and the panel highlight). Call it on session teardown so
 * measurements taken in one session never carry over into the next — in a SaMD
 * context a stale measurement shown against a different patient's image is a
 * misattribution hazard.
 *
 * The kind preference (`measurementModeState`) is intentionally left alone: it
 * is a UI preference, not session data.
 */
export function useResetMeasurements(): () => void {
    return useRecoilCallback(
        (callback) => () => {
            clearAnnotations(callback, measurementListState);
            callback.reset(measurementDraftState);
            callback.reset(highlightedMeasurementState);
        },
        []
    );
}
